mutation submitTextQuestion(
  $surveyCode: String!
  $questionId: Int!
  $value: String
  $isSkipped: Boolean
  $answerTimestamp: String!
) {
  submitTextQuestion(
    hashCode: $surveyCode
    questionId: $questionId
    answerText: $value
    skippedQuestion: $isSkipped
    answerTimestamp: $answerTimestamp
  ) {
    success
    error
  }
}
